import React, { useEffect, useState } from "react";
import { DEMO_SPEAKERS } from "../../features/demo/demoCatalog";
import EtikafSelect from "../EtikafSelect";

export const DemoSpeakerAvatar = ({ speaker, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const name = speaker?.name || "Ustaz demo";

  useEffect(() => setFailed(false), [speaker?.image]);

  if (!speaker?.image || failed) {
    return (
      <span
        className={`demo-speaker-avatar demo-speaker-avatar-fallback ${className}`.trim()}
        aria-label={`Avatar neutral ${name}`}
      >
        {name.replace(/^Ustaz\s+/i, "").charAt(0).toUpperCase() || "U"}
      </span>
    );
  }

  return (
    <img
      className={`demo-speaker-avatar ${className}`.trim()}
      src={speaker.image}
      alt={name}
      onError={() => setFailed(true)}
    />
  );
};

const DemoSpeakerSelect = ({ value, onChange, disabled = false }) => {
  const options = DEMO_SPEAKERS.map((speaker) => ({
    value: speaker.id,
    label: speaker.name,
    speaker,
  }));

  return (
    <EtikafSelect
      id="demo-kuliah-speaker"
      label="Ustaz"
      value={value}
      options={options}
      disabled={disabled}
      onChange={onChange}
      renderLeading={(option) => <DemoSpeakerAvatar speaker={option.speaker} />}
    />
  );
};

export default DemoSpeakerSelect;
